export default __webpack_public_path__ + "static/media/OUR PARTNERS.4a50cf39.png";